import React from 'react';

const FooterSettingsPanel = ({ theme, handleChange, handleAddFooterLink, handleRemoveFooterLink, handleFooterLinkChange }) => {
    return (
        <div className="notifications-panel mt-4">
            <div className="notifications-panel__header">
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-layout-footer"></i>
                    Footer Settings
                </span>
            </div>
            <div className="notifications-panel__body">
                <div className="mb-4">
                    <h6 className="fw-semibold mb-3">Footer Settings</h6>
                    <div className="row">
                        <div className="col-md-4">
                            <label className="form-label">Layout</label>
                            <select
                                className="form-control"
                                value={theme.footer.layout}
                                onChange={(e) => handleChange('footer', null, 'layout', e.target.value)}
                            >
                                <option value="default">Default</option>
                                <option value="minimal">Minimal</option>
                                <option value="detailed">Detailed</option>
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Background Color</label>
                            <div className="input-group">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.footer.backgroundColor === 'auto' ? theme.theme.colors.secondary : theme.footer.backgroundColor}
                                    onChange={(e) => handleChange('footer', null, 'backgroundColor', e.target.value)}
                                    style={{ width: '50px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.footer.backgroundColor}
                                    onChange={(e) => handleChange('footer', null, 'backgroundColor', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Text Color</label>
                            <div className="input-group">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.footer.textColor}
                                    onChange={(e) => handleChange('footer', null, 'textColor', e.target.value)}
                                    style={{ width: '50px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.footer.textColor}
                                    onChange={(e) => handleChange('footer', null, 'textColor', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <label className="form-label">Footer Text</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.footer.text}
                                onChange={(e) => handleChange('footer', null, 'text', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-4">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="footerShowContactInfo"
                                    checked={theme.footer.showContactInfo}
                                    onChange={(e) => handleChange('footer', null, 'showContactInfo', e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="footerShowContactInfo">
                                    Show Contact Info
                                </label>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="footerShowClinicHours"
                                    checked={theme.footer.showClinicHours}
                                    onChange={(e) => handleChange('footer', null, 'showClinicHours', e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="footerShowClinicHours">
                                    Show Clinic Hours
                                </label>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="footerShowSocialIcons"
                                    checked={theme.footer.showSocialIcons}
                                    onChange={(e) => handleChange('footer', null, 'showSocialIcons', e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="footerShowSocialIcons">
                                    Show Social Icons
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label className="form-label">Quick Links Font Size</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.footer.quickLinksFontSize}
                                onChange={(e) => handleChange('footer', null, 'quickLinksFontSize', e.target.value)}
                            />
                            <small className="text-muted">Accepts px, rem</small>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <label className="form-label">Quick Links</label>
                            {theme.footer.links.map((link, index) => (
                                <div key={index} className="input-group mb-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Link Text"
                                        value={link.text}
                                        onChange={(e) => handleFooterLinkChange(index, 'text', e.target.value)}
                                    />
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="URL"
                                        value={link.url}
                                        onChange={(e) => handleFooterLinkChange(index, 'url', e.target.value)}
                                    />
                                    <button
                                        className="btn btn-outline-danger"
                                        type="button"
                                        onClick={() => handleRemoveFooterLink(index)}
                                        disabled={theme.footer.links.length <= 1}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                            <button
                                className="btn btn-outline-primary mt-2"
                                type="button"
                                onClick={handleAddFooterLink}
                            >
                                Add Link
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FooterSettingsPanel;
